import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const BrandCtx = createContext({ brand: null, setBrand: () => {} });

export const BrandProvider = ({ children }) => {
  const [brand, setBrand] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setBrand(r.data));
  }, []);
  return <BrandCtx.Provider value={{ brand, setBrand }}>{children}</BrandCtx.Provider>;
};

export const useBrand = () => useContext(BrandCtx);
